import { connect } from "react-redux";
import FilterSection from "./FilterSection";
import { fetchSurveysFromTheOrg, getBenchmarkAlignmentScore, getBenchmarkKpiTiles, getBenchmarkTaxonomy, getCantAnswerResponses, getCommentsAndGist, getDevAndStrengthVisualization, getDistributionStrip, getOrgRaterGroups, getRankDelta, getRaterHeatmap, getSelfVsOthers, getTopStrengthTopDev, getTotalFeedbackProviders, handleChangeBenchmarkFilter } from "../../../../../../redux/actions";


const mapStateToProps = (state) => ({
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
    fetchSurveyLists: state.BenchmarkFilteringReducer.fetchSurveyLists,
    isVisualizationDataFectched: state.BenchmarkFilteringReducer.isVisualizationDataFectched,
    isSurveyListFetched: state.BenchmarkFilteringReducer.isSurveyListFetched,
    fetchOrgRaterGroupsApi: state.BenchmarkFilteringReducer.fetchOrgRaterGroupsApi


});

const mapDispatchToProps = (dispatch) => ({
    getBenchmarkTaxonomy: (payload) => dispatch((getBenchmarkTaxonomy(payload))),
    getOrgRaterGroups: (payload, cb) => dispatch(getOrgRaterGroups(payload, cb)),
    handleChangeBenchmarkFilter: (payload) => dispatch(handleChangeBenchmarkFilter(payload)),
    getCantAnswerResponses: (payload) => dispatch(getCantAnswerResponses(payload)),
    getDevAndStrengthVisualization: (payload) => dispatch(getDevAndStrengthVisualization(payload)),
    getTopStrengthTopDev: (payload) => dispatch(getTopStrengthTopDev(payload)),
    getTotalFeedbackProviders: (payload) => dispatch(getTotalFeedbackProviders(payload)),
    fetchSurveysFromTheOrg: (payload, cb) => dispatch(fetchSurveysFromTheOrg(payload, cb)),
    getRaterHeatmap: (payload) => dispatch(getRaterHeatmap(payload)),
    getBenchmarkKpiTiles: (payload) => dispatch(getBenchmarkKpiTiles(payload)),
    getSelfVsOthers: (payload) => dispatch(getSelfVsOthers(payload)),
    getDistributionStrip: (payload) => dispatch(getDistributionStrip(payload)),
    getRankDelta: (payload) => dispatch(getRankDelta(payload)),
    getCommentsAndGist: (payload) => dispatch(getCommentsAndGist(payload)),
    getBenchmarkAlignmentScore: (payload) => dispatch(getBenchmarkAlignmentScore(payload))



});

export default connect(mapStateToProps, mapDispatchToProps)(FilterSection);
